<template>
  <v-menu class="filterMenu" v-model="menu" :close-on-content-click="false" location="bottom" style="max-width: 500px; max-height: 700px">
    <template v-slot:activator="{ props: menu }">
      <v-tooltip :text="$t('messages.showFilters')">
        <template v-slot:activator="{ props: tooltip }">
          <v-btn
            v-bind="mergeProps(menu, tooltip)"
            flat
            large
            block
            class="secondaryButton"
          >
            <v-icon size="xx-large">mdi-filter-variant</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </template>

    <v-card min-width="300" class="pa-4 pb-0">
      <slot />

      <v-card-actions class="my-4">
        <v-btn v-if="resetFilterButton" class="secondaryButton pl-4" style="width: 35%" @click="resetFilter()">
          {{ $t("basics.reset") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primaryButton pl-4" style="width: 55%" @click="applyFilter()">
          {{ $t("basics.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mergeProps } from "vue";

export default {
  name: "filterMenuComponent",
  props: ["resetFilterButton"],

  data() {
    return {
      menu: false,
    };
  },

  watch: {
    menu(){
      if(this.menu){
        this.$emit("openMenu")
      }
    }
  },

  methods: {
    mergeProps,
    applyFilter(){
      
      this.$emit("applyFilter")
      this.menu = false;
    },

    resetFilter(){
      this.$emit("resetFilter")
    }
  },
};
</script>
